import { PDF_MIME_TYPE, TEXT_STRING, ZIP_MIME_TYPE } from '../constants';

/**
 * 個別チャットでダウンロードカードとして描く文書系添付の種別。
 * Icon コンポーネントのアイコン名（iconPath の 'pdf' / 'zip'）と一致させる。
 * NOTE: management の components/Chat/constants.ts（isChatDocumentKind / CHAT_DOCUMENT_STRINGS）と対になる。
 * 文書系の種別を増やすときは両方を更新すること。
 */
export type TChatDocumentKind = 'pdf' | 'zip';

export type TChatDocumentPresentation = {
  /** Icon に渡すアイコン名 */
  kind: TChatDocumentKind;
  /** media[].fileName が無いときの既定ラベル */
  fileName: string;
  /** カード下部に出す操作ヒント */
  openHint: string;
  /** URL が http(s) でなく開けないときの文言 */
  unavailable: string;
};

const PDF_PRESENTATION: TChatDocumentPresentation = {
  kind: 'pdf',
  fileName: TEXT_STRING.MESSAGE.PDF_FILE,
  openHint: TEXT_STRING.MESSAGE.PDF_OPEN_HINT,
  unavailable: TEXT_STRING.MESSAGE.PDF_UNAVAILABLE,
};

const ZIP_PRESENTATION: TChatDocumentPresentation = {
  kind: 'zip',
  fileName: TEXT_STRING.MESSAGE.ZIP_FILE,
  openHint: TEXT_STRING.MESSAGE.ZIP_OPEN_HINT,
  unavailable: TEXT_STRING.MESSAGE.ZIP_UNAVAILABLE,
};

/**
 * メッセージの media[].type から文書カードの表示情報を返す。
 * MessageItem（先頭 media の専用カード）と MediaView（防御的な `<a>` 分岐）で同じ判定を共有する。
 *
 * type は PubNub ペイロード由来（any）なので object lookup ではなく完全一致で判定する
 * （'constructor' 等のプロトタイプ由来キーで truthy にならないように）。
 * PDF / ZIP の正規 MIME 以外は undefined（画像・動画は従来の分岐で描画する）。
 */
export const getChatDocumentPresentation = (
  type: unknown,
): TChatDocumentPresentation | undefined =>
  type === PDF_MIME_TYPE
    ? PDF_PRESENTATION
    : type === ZIP_MIME_TYPE
    ? ZIP_PRESENTATION
    : undefined;
